export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE";
export const uploadFileSuccess = (payload) => ({
    type: UPLOAD_FILE_SUCCESS,
    payload,
});
export const uploadFileRequest = (payload) => ({
    type: UPLOAD_FILE_REQUEST,
    payload,
});
export const uploadFileFailure = (payload) => ({
    type: UPLOAD_FILE_FAILURE,
    payload,
});
